import roundDecimals from '@/domains/common/services/utils/roundDecimals';

const createNumberArray = ({ start, stop, step }: { start: number; stop: number; step: number }): number[] => {
    const array: number[] = [];

    for (let i = start; i <= stop; i += step) {
        array.push(roundDecimals(i));
    }

    return array;
};

export default createNumberArray;
